import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Activity, Check, Edit, LogOut, Plus, Trash2, UserPlus } from "lucide-react";

// Audit log / recent activity feed.
const ActivityTab = ({
  auditLogs,
}) => {
  return (
    <div className="activity-view">
      <div className="view-header">
        <h1>Aktywność</h1>
      </div>

      {auditLogs.length === 0 ? (
        <Card className="empty-state">
          <CardContent>
            <Activity size={48} strokeWidth={1} />
            <h3>Brak aktywności</h3>
            <p>Tu pojawią się logi akcji</p>
          </CardContent>
        </Card>
      ) : (
        <div style={{padding: '16px 32px', display: 'flex', flexDirection: 'column', gap: '8px'}}>
          {auditLogs.map(log => (
            <Card key={log.id}>
              <CardContent style={{display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 16px'}}>
                <div style={{width: 36, height: 36, borderRadius: '50%', background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0}}>
                  {log.action === 'login' ? <LogOut size={16} /> :
                   log.action === 'register' ? <UserPlus size={16} /> :
                   log.action === 'create' ? <Plus size={16} /> :
                   log.action === 'update' ? <Edit size={16} /> :
                   log.action === 'delete' ? <Trash2 size={16} /> :
                   log.action === 'submit' ? <Check size={16} /> :
                   <Activity size={16} />}
                </div>
                <div style={{flex: 1, minWidth: 0}}>
                  <div style={{fontWeight: 500, fontSize: '0.9rem'}}>{log.user_name}</div>
                  <div style={{color: 'var(--text-secondary)', fontSize: '0.8rem'}}>
                    {log.action} {log.resource_type}{log.details?.name ? ` — ${log.details.name}` : ''}
                  </div>
                </div>
                <div style={{color: 'var(--text-muted)', fontSize: '0.75rem', flexShrink: 0}}>
                  {new Date(log.created_at).toLocaleString('pl-PL', {day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit'})}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default ActivityTab;
